module.exports = require("current-git-branch");


//////////////////
// WEBPACK FOOTER
// external "current-git-branch"
// module id = 87
// module chunks = 0